import {
  ChangeDetectorRef,
  Component,
  inject,
  Input,
  OnDestroy,
} from '@angular/core';

import pdfMake from 'pdfmake/build/pdfmake';
import htmlToPdfmake from 'html-to-pdfmake';
import { TDocumentDefinitions } from 'pdfmake/interfaces';
import { Subject } from 'rxjs';
import { PrintTemplateData } from '../../../feedback-step.interface';
import { CommonModule } from '@angular/common';
@Component({
  selector: 'app-print-template',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './print-template.component.html',
})
export class PrintTemplateComponent implements OnDestroy {
  private cd = inject(ChangeDetectorRef);
  initialized = false;
  printData: PrintTemplateData | null = null;
  private readonly destroy$ = new Subject<void>();
  @Input() set templateData(val: PrintTemplateData | null) {
    this.initializeData(val);
  }

  private async initializeData(val: PrintTemplateData | null) {
    if (!val) {
      this.printData = null;
      this.initialized = false;
      this.cd.detectChanges();
      return;
    }
    this.printData = val;
    this.cd.detectChanges();
    this.initialized = true;
  }

  async printPDF() {
    if (this.printData) {
      const pdfContent = document.getElementById('pdf-data');
      if (pdfContent) {
        let pdfMakeContent = htmlToPdfmake(pdfContent.innerHTML);
        if (Array.isArray(pdfMakeContent)) {
          //ToDO: once version of pdfMake udpdate then we ca nremove any type
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          pdfMakeContent = pdfMakeContent.map((contentItem: any) => {
            return {
              ...contentItem,
              pageBreak: 'avoid',
              margin: [0, 10, 0, 10],
            };
          });
        }

        const documentDefinition: TDocumentDefinitions = {
          content: pdfMakeContent,
          pageMargins: [20, 20, 20, 20],
          pageBreakBefore: function () {
            return false;
          },
          footer: function (currentPage: number) {
            return {
              columns: [
                {
                  text: ``,
                  alignment: 'left',
                },
                {
                  text: `Powered by Insights to Behavior®`,
                  alignment: 'center',
                },
                {
                  text: `${currentPage}`,
                  alignment: 'right',
                },
              ],
              margin: [15, 0, 10, 0],
              color: '#475467',
            };
          },
          styles: {
            questionContainer: {
              margin: [0, 5, 0, 5],
            },
            questionHeader: {
              marginBottom: 5,
              bold: true,
              fontSize: 14,
            },
            stepIndicator: {
              fillColor: '#d1f7d6',
              color: '#22c55e',
              fontSize: 14,
              margin: [0, 0, 10, 0],
              alignment: 'left',
            },
            questionText: {
              fontSize: 12,
              marginBottom: 3,
              color: '#475467',
            },
            datalabel: {
              lineHeight: 1.5,
              color: '#475467',
            },
            dataValue: {
              color: '#475467',
            },
            columns: {
              columnGap: 10,
            },
            chartImage: {
              alignment: 'center',
            },
          },
          defaultStyle: {
            columnGap: 10,
            fontSize: 12,
            lineHeight: 1.2,
          },
        };

        pdfMake
          .createPdf(documentDefinition)
          .download(
            `${this.printData.selectedTab}-Self-Assessment-Feedback-template.pdf`
          );
        this.initialized = false;
        this.ngOnDestroy();
      }
    }
  }

  generateTextBox() {
    return JSON.stringify({
      columns: [
        {
          width: '*',
          canvas: [
            {
              type: 'rect',
              x: 0,
              y: 0,
              w: 552,
              h: 50,
              lineWidth: 1,
              lineColor: '#475467',
              color: '#f9f9f9',
              r: 4,
            },
          ],
          margin: [0, 5, 0, 10],
        },
      ],
    });
  }

  getSectionTitle(subCategoryId: number): string {
    switch (subCategoryId) {
      case 1:
        return 'Teachers';
      case 2:
        return 'Students';
      default:
        return 'Questions';
    }
  }

  generateImageData(imageSource: string | undefined): string {
    if (!imageSource) return JSON.stringify({});

    return JSON.stringify({
      image: imageSource,
      width: 100,
      height: 'auto',
      margin: [0, 0, 10, 0],
    });
  }

  generateOptionsRow(options: string[]) {
    const optionColumns = options.map(item => {
      return {
        width: 'auto',
        margin: [2, 3, 8, 0],
        columns: [
          {
            width: 'auto',
            canvas: [
              {
                type: 'ellipse',
                x: 5,
                y: 5,
                r1: 5,
                r2: 5,
                lineWidth: 1,
                lineColor: '#475467',
              },
              {
                type: 'ellipse',
                x: 5,
                y: 5,
                r1: 2.5,
                r2: 2.5,
                color: '#ffffff',
              },
            ],
            margin: [0, 0, 2, 0],
          },
          {
            width: 'auto',
            text: item,
            fontSize: 12,
            color: '#475467',
            margin: [0, 0, 0, 0],
          },
        ],
      };
    });

    return JSON.stringify({
      columns: optionColumns,
      columnGap: 12,
      margin: [0, 5, 0, 10],
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    this.printData = null;
  }
}
